import Papa from 'papaparse';
import { downloadCSV } from '../../../../utils/utils';

const TEMPLATE_FILENAME = 'CreateUsersTemplate.csv';

// Blank template row with all required/optional columns
// 'Account Type' accepts 'User' or 'Ring Group' (defaults to 'User' if left blank).
// 'Platform Extension' only applies to 'Ring Group' rows.
const TEMPLATE_ROW = {
    'Account Type': '',
    'First Name': '',
    'Last Name': '',
    Email: '',
    Site: '',
    'Platform Extension': '',
};

export default function useCSVCreateTemplate() {
    const handleDownloadTemplate = () => {
        const res = Papa.unparse([TEMPLATE_ROW]);
        downloadCSV(res, TEMPLATE_FILENAME);
    };

    return {
        handleDownloadTemplate,
        loading: false,
        error: false,
    };
}
